// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"ConfirmDeleteCommentModal_buttonsWrapper__GIMkU"};